import React from 'react';
import { ToastContainer } from 'react-toastify';

const PublicLayout = ({children}) => (
  <div>
    {children}
    <ToastContainer
                position="bottom-center"
                autoClose={500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
  </div>
);

export default PublicLayout;